// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown.ui.dropdown {\n\topacity: 1;\n}\n\n.form.ui.form {\n\topacity: 1;\n}\n\n.input.ui.input {\n\topacity: 1;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Lumber/GroundData/Assessment/style.css"],"names":[],"mappings":"AAAA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX","sourcesContent":[".dropdown.ui.dropdown {\n\topacity: 1;\n}\n\n.form.ui.form {\n\topacity: 1;\n}\n\n.input.ui.input {\n\topacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": "dropdown",
	"ui": "ui",
	"form": "form",
	"input": "input"
};
export default ___CSS_LOADER_EXPORT___;
